/* ==========================================================================
   AEVORA — theme.js
   JS global, vanilla, sans dépendance. Progressive enhancement.
   Modules : nav mobile · cart drawer (fetch AJAX) · product form + variantes
             · accordéon FAQ · galerie produit · carrousels (scroll natif)
   ========================================================================== */
(function () {
  'use strict';

  var A = window.AEVORA || {};
  var routes = A.routes || {};
  var moneyFormat = A.moneyFormat || '{{amount}} €';

  // Icônes fines (line) — remplacent les emojis pour un rendu premium
  var IC_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5V12l3.2 1.9"/></svg>';
  var IC_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6h10.5v9.5H2.5z"/><path d="M13 9h4l3.5 3.5v3H13z"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>';
  var IC_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4z"/><path d="M2.5 7.5h19V11h-19z"/><path d="M12 7.5V20"/><path d="M12 7.5S10.5 3.5 8 4.2C6.2 4.7 6.6 7.5 9 7.5z"/><path d="M12 7.5S13.5 3.5 16 4.2C17.8 4.7 17.4 7.5 15 7.5z"/></svg>';

  // Logos de paiement : AUCUN SVG maison. Le markup vient des VRAIES icônes
  // Shopify rendues en Liquid (snippets/payment-icons.liquid) dans le
  // <template data-pay-icons> du cart drawer — donc uniquement les moyens de
  // paiement réellement acceptés par la boutique (shop.enabled_payment_types).
  function payIconsHTML() {
    var tpl = document.querySelector('template[data-pay-icons]');
    return tpl ? tpl.innerHTML : '';
  }

  /* ---------- Utilitaires ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // Gère TOUS les placeholders Shopify (amount, amount_with_comma_separator,
  // amount_no_decimals, amount_with_space_separator…) — sinon le format brut
  // {{amount_with_comma_separator}} s'affiche tel quel dans le panier.
  function formatMoney(cents) {
    cents = cents || 0;
    function withSep(amount, decimals, thousands, decimalMark) {
      var n = (cents / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts.join(decimalMark) : parts[0];
    }
    return (moneyFormat || '{{amount}} €').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withSep(cents, 2, ',', ',');
        case 'amount_no_decimals': return withSep(cents, 0, ',', ',');
        case 'amount_with_comma_separator': return withSep(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withSep(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withSep(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withSep(cents, 2, "'", '.');
        default: return withSep(cents, 2, ',', ',');
      }
    });
  }

  function on(el, evt, cb) { if (el) el.addEventListener(evt, cb); }

  /* ---------- Overlay partagé ---------- */
  var overlay = $('.overlay');
  function openOverlay() { if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeOverlay() {
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    closeMobileNav();
    closeCart();
  }
  on(overlay, 'click', closeOverlay);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlay(); });

  /* ---------- Nav mobile ---------- */
  var mobileNav = $('.mobile-nav');
  // Le menu mobile est rendu dans le header sticky (contexte d'empilement) → il
  // passait SOUS le voile. On le remonte au niveau <body> pour qu'il s'affiche
  // au-dessus du voile et redevienne cliquable.
  if (mobileNav && mobileNav.parentNode !== document.body) { document.body.appendChild(mobileNav); }
  function closeMobileNav() { if (mobileNav) mobileNav.classList.remove('is-open'); }
  $all('[data-nav-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      if (!mobileNav) return;
      mobileNav.classList.add('is-open');
      openOverlay();
    });
  });
  $all('[data-nav-close]').forEach(function (b) { on(b, 'click', closeOverlay); });

  /* ======================================================================
     CART DRAWER
     ====================================================================== */
  var drawer = $('.cart-drawer');
  var cartItemsEl = $('[data-cart-items]');
  var cartFootEl = $('[data-cart-foot]');
  var shipBarEl = $('[data-ship-bar]');
  var upsellsEl = $('[data-cart-upsells]');
  var cartCountEls = $all('[data-cart-count]');
  // Livraison offerte SANS SEUIL (zone Deutschland = 0,00 €). data-free-ship =
  // "always" (offerte sans condition) ou "0" (mention masquée). Aucun seuil,
  // donc aucune barre de progression : on ne simule pas une condition inexistante.
  var FREE_SHIP_RAW = drawer ? (drawer.getAttribute('data-free-ship') || '0') : '0';
  var FREE_SHIP_ALWAYS = FREE_SHIP_RAW === 'always';

  function openCart() { if (drawer) drawer.classList.add('is-open'); openOverlay(); }
  function closeCart() { if (drawer) drawer.classList.remove('is-open'); }

  $all('[data-cart-open]').forEach(function (b) {
    on(b, 'click', function (e) { e.preventDefault(); openCart(); refreshCart(); });
  });
  $all('[data-cart-close]').forEach(function (b) { on(b, 'click', closeCart); });

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  // Mention « livraison offerte » — statique : le port est gratuit sans condition,
  // donc pas de barre de progression ni de « plus que X € » (fausse promesse).
  function renderShipBar(cart) {
    if (!shipBarEl) return;
    if (cart.item_count === 0 || !FREE_SHIP_ALWAYS) { shipBarEl.hidden = true; shipBarEl.innerHTML = ''; return; }
    shipBarEl.hidden = false;
    shipBarEl.className = 'cd-ship cd-ship--done';
    shipBarEl.innerHTML = '<div class="cd-ship__msg" style="margin:0"><span class="cd-ship__ic">' + IC_TRUCK + '</span><span><b>Kostenloser Versand</b> inklusive</span></div>';
  }

  // Masque les upsells déjà au panier ; masque tout le bloc si panier vide.
  function renderUpsells(cart) {
    if (!upsellsEl) return;
    if (cart.item_count === 0) { upsellsEl.hidden = true; return; }
    var handles = cart.items.map(function (it) { return it.handle; });
    var anyVisible = false;
    $all('[data-upsell]', upsellsEl).forEach(function (row) {
      var inCart = handles.indexOf(row.getAttribute('data-upsell-handle')) !== -1;
      row.hidden = inCart;
      if (!inCart) anyVisible = true;
    });
    upsellsEl.hidden = !anyVisible;
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    updateCartCount(cart.item_count);
    if (drawer) drawer.classList.toggle('has-items', cart.item_count > 0);
    renderShipBar(cart);
    renderUpsells(cart);

    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '<div class="cart-empty"><p>Ihr Warenkorb ist leer.</p><a class="btn btn--accent" href="/products/rasoir-aevora">Jetzt entdecken</a></div>';
      if (cartFootEl) cartFootEl.innerHTML = '';
      return;
    }

    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
      // Ligne cadeau : les 100 lames offertes (prix ligne à 0 via la remise auto).
      var isGift = item.variant_id === FREE_BLADES_VID || item.final_line_price === 0;
      if (isGift) {
        return '' +
          '<div class="cart-line cart-line--gift" data-key="' + item.key + '">' +
            '<img loading="lazy" src="' + img + '" alt="' + (item.product_title || '') + '" width="64" height="64">' +
            '<div>' +
              '<div class="cart-line__title">' + item.product_title + ' <span class="cart-line__gift-badge">Geschenk</span></div>' + variant +
              '<div class="cart-line__gift-note">Gratis zu Ihrem Rasierhobel</div>' +
            '</div>' +
            '<div class="cart-line__price cart-line__price--gift"><s>' + formatMoney(item.original_line_price) + '</s> Gratis</div>' +
          '</div>';
      }
      return '' +
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<img loading="lazy" src="' + img + '" alt="' + (item.product_title || '') + '" width="64" height="64">' +
          '<div>' +
            '<div class="cart-line__title">' + item.product_title + '</div>' + variant +
            '<div class="cart-qty" data-key="' + item.key + '">' +
              '<button class="cart-qty__btn" data-qty-minus aria-label="Eins entfernen">–</button>' +
              '<span class="cart-qty__val">' + item.quantity + '</span>' +
              '<button class="cart-qty__btn" data-qty-plus aria-label="Eins hinzufügen">+</button>' +
            '</div>' +
            '<button class="cart-line__remove" data-remove>Entfernen</button>' +
          '</div>' +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    cartItemsEl.innerHTML = html;

    if (cartFootEl) {
      cartFootEl.innerHTML =
        '<div class="cart-drawer__totals"><span>Gesamtsumme</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<div class="cart-drawer__reassure"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg> Sichere Zahlung · 100 Tage Geld-zurück-Garantie</div>' +
        payIconsHTML() +
        '<a href="/checkout" class="btn btn--primary btn--full cart-drawer__checkout"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg> Zur Kasse <span class="cd-co-total">· ' + formatMoney(cart.total_price) + '</span></a>' +
        '<a href="' + (routes.cart_url || '/cart') + '" class="cart-drawer__view">Warenkorb ansehen</a>';
    }
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    if (drawer) drawer.classList.add('loading');
    fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {})
      .finally(function () { if (drawer) drawer.classList.remove('loading'); });
  }

  // Délégation d'événements pour +/-/retirer dans le drawer
  on(cartItemsEl, 'click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var valEl = line.querySelector('.cart-qty__val');
    var qty = valEl ? parseInt(valEl.textContent, 10) : 1;
    if (e.target.hasAttribute('data-qty-plus')) changeLine(key, qty + 1);
    else if (e.target.hasAttribute('data-qty-minus')) changeLine(key, Math.max(0, qty - 1));
    else if (e.target.hasAttribute('data-remove')) changeLine(key, 0);
  });

  // Upsells du drawer : swatch de couleur -> change la variante ; « + Ajouter » -> ajout AJAX.
  if (upsellsEl) {
    on(upsellsEl, 'click', function (e) {
      var sw = e.target.closest('[data-upsell-swatches] [data-variant]');
      if (sw) {
        e.preventDefault();
        var grp = sw.closest('[data-upsell-swatches]');
        $all('[data-variant]', grp).forEach(function (b) { b.classList.remove('is-active'); });
        sw.classList.add('is-active');
        var it = sw.closest('[data-upsell]');
        var add = it && it.querySelector('[data-upsell-add]');
        if (add) add.setAttribute('data-upsell-add', sw.getAttribute('data-variant'));
        return;
      }
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      var vid = parseInt(btn.getAttribute('data-upsell-add'), 10);
      if (vid) addToCart([{ id: vid, quantity: 1 }], btn);
    });
  }

  // Swatches de couleur dans le bundle (fiche produit) : choisir la variante ajoutée.
  $all('[data-bundle-swatches]').forEach(function (group) {
    on(group, 'click', function (e) {
      var sw = e.target.closest('[data-variant]');
      if (!sw) return;
      e.preventDefault(); e.stopPropagation();
      $all('[data-variant]', group).forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      sw.classList.add('is-active'); sw.setAttribute('aria-pressed', 'true');
      var item = group.closest('.bundle__item');
      var cb = item && item.querySelector('[data-bundle-add]');
      if (cb) cb.value = sw.getAttribute('data-variant');
    });
  });

  /* ---------- Ajout au panier (formulaire produit + cross-sell) ---------- */
  function addToCart(items, btn) {
    if (btn) { btn.classList.add('loading'); btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () { refreshCart(); openCart(); })
      .catch(function (err) { alert((err && err.description) || 'Produkt nicht verfügbar.'); })
      .finally(function () { if (btn) { btn.classList.remove('loading'); if (btn.dataset.label) btn.textContent = btn.dataset.label; } });
  }

  // 100 lames OFFERTES : ajoutées AUTOMATIQUEMENT au panier avec le rasoir (sans
  // clic). Elles sont rendues gratuites par la remise auto « Rasoir acheté = 100
  // lames offertes ». On ne les ajoute qu'une fois (jamais en double).
  var FREE_BLADES_VID = 56711493943636;   // variante « Pack de 100 lames »
  var RAZOR_HANDLE = 'rasoir-aevora';
  function isRazorPage() { return location.pathname.indexOf('/products/' + RAZOR_HANDLE) !== -1; }
  function cartHasBlades(cart) {
    return !!(cart && cart.items && cart.items.some(function (it) { return it.variant_id === FREE_BLADES_VID; }));
  }

  // Formulaires product-form (fiche produit + cross-sell rapide)
  $all('form[data-product-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      var btn = form.querySelector('[type="submit"]');
      var items = [{ id: parseInt(id.value, 10), quantity: qty }];
      // Add-ons du bundle cochés (socle, étui…) — ajoutés dans le même /cart/add
      $all('[data-bundle-add]:checked', form).forEach(function (cb) {
        var vid = parseInt(cb.value, 10);
        if (vid) items.push({ id: vid, quantity: 1 });
      });
      var isMainRazor = FREE_BLADES_VID && isRazorPage() && !form.classList.contains('cross-sell__item') && form.closest('[data-product-root]');
      if (isMainRazor) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (!cartHasBlades(cart)) items.push({ id: FREE_BLADES_VID, quantity: 1 }); })
          .catch(function () {})
          .then(function () { addToCart(items, btn); });
      } else {
        addToCart(items, btn);
      }
    });
  });

  /* ======================================================================
     VARIANTES PRODUIT
     Sélecteur simple (une seule décision). Met à jour l'input caché + prix.
     Les données variantes sont injectées en JSON dans [data-variant-json].
     ====================================================================== */
  $all('[data-variant-picker]').forEach(function (picker) {
    var root = picker.closest('[data-product-root]') || document;
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price-now]');
    var submitBtn = root.querySelector('form[data-product-form] [type="submit"]');
    var chips = $all('.variant-chip', picker);
    var labelValue = picker.querySelector('[data-variant-current]');

    function select(chip) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      var vid = chip.getAttribute('data-variant-id');
      if (idInput) idInput.value = vid;
      var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
      if (v) {
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (labelValue) labelValue.textContent = chip.getAttribute('data-variant-title') || '';
        // Bouton d'achat synchronisé avec la disponibilité de la finition choisie
        if (submitBtn) {
          var out = v.available === false;
          submitBtn.disabled = out;
          submitBtn.classList.toggle('is-soldout', out);
          if (out) { if (!submitBtn.dataset.instock) submitBtn.dataset.instock = submitBtn.textContent; submitBtn.textContent = 'Ausverkauft'; }
          else if (submitBtn.dataset.instock) { submitBtn.textContent = submitBtn.dataset.instock; }
        }
      }
    }
    chips.forEach(function (chip) { on(chip, 'click', function () { select(chip); }); });
  });

  /* ======================================================================
     ACCORDÉON FAQ
     ====================================================================== */
  var faqItems = $all('.faq__item');
  faqItems.forEach(function (item) {
    var q = item.querySelector('.faq__q');
    var a = item.querySelector('.faq__a');
    on(q, 'click', function () {
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (a) a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });
  // Recalcule la hauteur des réponses ouvertes au redimensionnement / après swap de police
  // (sinon le texte est coupé quand la largeur change ou que la police charge).
  var faqResizeTimer;
  on(window, 'resize', function () {
    clearTimeout(faqResizeTimer);
    faqResizeTimer = setTimeout(function () {
      faqItems.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var a = item.querySelector('.faq__a');
        if (a) { a.style.maxHeight = 'none'; a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    }, 120);
  });

  /* ======================================================================
     GALERIE PRODUIT (thumbs -> main)
     ====================================================================== */
  $all('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    var thumbs = $all('[data-gallery-thumb]', gal);
    thumbs.forEach(function (thumb) {
      on(thumb, 'click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (main && src) main.innerHTML = '<img src="' + src + '" alt="' + alt + '">';
      });
    });
  });

  /* ======================================================================
     REVEAL AU SCROLL — enhancement vanilla, un seul IntersectionObserver.
     Réplique le « vivant » du concurrent (Focal/WAAPI) sans dépendance ni lib.
     Gardé par prefers-reduced-motion + présence d'IntersectionObserver ; le
     contenu reste 100% visible si l'un manque (le CSS ne cache que sous .js +
     motion autorisé). On n'anime QUE ce qui est sous la ligne de flottaison
     → zéro flash au-dessus. Filet de sécurité : tout révélé après 4 s.
     ====================================================================== */
  (function initReveal() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var SEL = '.section-head,.product-card,.usage-step,.benefit,.result-stat,.testi-card,.faq__item,.fr-item,.specs-table,.compare,[data-reveal]';
    // Marque les éléments ciblés (les .reveal écrits en dur dans le Liquid sont déjà marqués).
    $all(SEL).forEach(function (el) { el.classList.add('reveal'); });
    var all = $all('.reveal');
    if (!all.length) return;
    // Pas d'animation possible -> TOUT visible immédiatement (jamais de contenu caché = fini les grands blancs).
    if (reduce || !('IntersectionObserver' in window)) {
      all.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    all.forEach(function (el) {
      // Déjà dans/proche de l'écran au chargement -> révélé tout de suite (pas d'attente ni de vide).
      if (el.getBoundingClientRect().top <= vh * 0.9) { el.classList.add('is-in'); return; }
      var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      el.style.transitionDelay = Math.min(sib, 5) * 70 + 'ms';   // cascade naturelle, bornée
      io.observe(el);
    });
    // Filet de sécurité : tout révélé après 3s quoi qu'il arrive.
    setTimeout(function () { all.forEach(function (el) { el.classList.add('is-in'); }); }, 3000);
  })();

  /* ======================================================================
     STICKY ATC (mobile) — barre d'achat toujours visible sur la fiche produit.
     Corrige « bouton introuvable / trop bas » : la galerie remplit l'écran et
     le vrai bouton passe sous la ligne de flottaison. On clone prix + bouton
     dans une barre fixe qui apparaît dès que le vrai bouton n'est plus visible.
     ====================================================================== */
  (function stickyATC() {
    var root = $('[data-product-root]');
    var form = root && root.querySelector('form[data-product-form]');
    var atc = form && form.querySelector('[type="submit"]');
    if (!root || !form || !atc) return;
    var priceEl = root.querySelector('[data-price-now]');
    var titleEl = root.querySelector('.product-info__title');
    var bar = document.createElement('div');
    bar.className = 'sticky-atc';
    bar.innerHTML = '<div class="sticky-atc__info"><span class="sticky-atc__name"></span><span class="sticky-atc__price"></span></div><button type="button" class="btn btn--accent sticky-atc__btn"></button>';
    document.body.appendChild(bar);
    var nameEl = bar.querySelector('.sticky-atc__name');
    var barPrice = bar.querySelector('.sticky-atc__price');
    var barBtn = bar.querySelector('.sticky-atc__btn');
    if (nameEl && titleEl) nameEl.textContent = titleEl.textContent.trim();
    function sync() {
      if (priceEl) barPrice.textContent = priceEl.textContent;
      barBtn.disabled = atc.disabled;
      barBtn.textContent = atc.disabled ? 'Ausverkauft' : (atc.textContent || 'In den Warenkorb').trim();
    }
    sync();
    on(barBtn, 'click', function () { if (atc.disabled) return; if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0 }).observe(atc);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(atc, { attributes: true, childList: true, subtree: true });
      if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  })();

  /* ======================================================================
     BADGES DE PAIEMENT — plus aucune injection JS de SVG « maison ».
     Les logos sont rendus en Liquid (snippets/payment-icons.liquid) :
       · fiche produit  → sous le bouton « In den Warenkorb »
       · page d'accueil → sous le bandeau de réassurance
       · footer         → .payment-icons (payment_type_svg_tag)
       · cart drawer    → clone du <template data-pay-icons>, au-dessus de « Zur Kasse »
     Un seul système, des icônes officielles Shopify, jamais un moyen de
     paiement que la boutique n'accepte pas.
     ====================================================================== */

  /* ======================================================================
     COMPTE À REBOURS PANIER (drawer) — urgence douce. IMPORTANT : purement
     visuel. À 0:00 il se FIGE, plus rien ne se passe — on ne vide JAMAIS le
     panier (contrairement à Lamier qui fait POST /cart/clear.js à 0). Demandé
     explicitement par Camil ; comportement non hostile assumé.
     ====================================================================== */
  (function cartTimer() {
    var el = $('[data-cd-timer]');
    if (!el) return;
    var DURATION = 15 * 60 * 1000;
    var KEY = 'cd_timer_end';
    var end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!end) { end = Date.now() + DURATION; try { sessionStorage.setItem(KEY, String(end)); } catch (e) {} }
    var iv;
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) {
        el.classList.add('is-done');
        el.innerHTML = '<span class="cd-timer__ic">' + IC_CLOCK + '</span> Reservierung abgelaufen';
        if (iv) clearInterval(iv);
        return; // FIGÉ : aucune action, le panier reste intact
      }
      var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
      el.innerHTML = '<span class="cd-timer__ic">' + IC_CLOCK + '</span> Artikel reserviert <b>' + m + ':' + (s < 10 ? '0' : '') + s + '</b>';
    }
    tick();
    iv = setInterval(tick, 1000);
  })();

  /* ======================================================================
     STATS ANIMÉES — barres de répartition d'avis qui se remplissent + compteurs
     qui montent, à l'apparition au scroll. Gardé reduced-motion / no-IO.
     ====================================================================== */
  (function animatedStats() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function fillBars(sum) {
      $all('.rsum-bar', sum).forEach(function (bar) {
        var i = bar.querySelector('i'); if (!i) return;
        var pct = parseFloat(i.getAttribute('data-w')) || 0;
        i.style.width = Math.round(bar.clientWidth * pct / 100) + 'px';
      });
    }
    function setFinal(el) { el.textContent = (el.getAttribute('data-prefix') || '') + el.getAttribute('data-count').replace('.', ',') + (el.getAttribute('data-suffix') || ''); }
    if (!('IntersectionObserver' in window)) {
      $all('.reviews-summary').forEach(fillBars);
      $all('[data-count]').forEach(setFinal);
      return;
    }
    $all('.reviews-summary').forEach(function (sum) {
      new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { fillBars(sum); o.disconnect(); } }); }, { threshold: .25 }).observe(sum);
    });
    $all('[data-count]').forEach(function (el) {
      var raw = el.getAttribute('data-count'), num = parseFloat(raw.replace(/\s/g, '').replace(',', '.'));
      var prefix = el.getAttribute('data-prefix') || '', suffix = el.getAttribute('data-suffix') || '';
      var dec = /[.,]/.test(raw) ? 1 : 0;
      if (isNaN(num) || reduce) { setFinal(el); return; }
      new IntersectionObserver(function (es, o) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; o.disconnect();
          var start = null;
          function step(t) {
            if (start === null) start = t;
            var p = Math.min((t - start) / 1100, 1), eased = num * (1 - Math.pow(1 - p, 3));
            el.textContent = prefix + eased.toFixed(dec).replace('.', ',') + suffix;
            if (p < 1) requestAnimationFrame(step); else setFinal(el);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: .5 }).observe(el);
    });
  })();

  /* ---------- Init (déféré hors du chemin critique pour l'INP) ---------- */
  if ('requestIdleCallback' in window) {
    requestIdleCallback(refreshCart, { timeout: 1500 });
  } else {
    setTimeout(refreshCart, 400);
  }
})();
